import { Link } from "react-router-dom";
import { Quote } from "~/shared/components/texts";
import {
  FlexColumn,
  FlexRow,
  FlexRowSpaceBetween,
} from "~/shared/components/flexes";
import { ReactComponent as ZigzagLine } from "~/shared/assets/zigzagLine.svg";
import {
  Headline4,
  LargeText,
  SmallText,
  RegularText,
} from "~/shared/components/typography";
import ravZuckerman from "~/shared/assets/rav-zuckerman.jpeg";
import styled from "styled-components";
import WhatsappButton from "./WhatsappButton";

const Wrapper = styled(FlexColumn)`
  gap: 10px;
`;

const Texts = styled(FlexColumn)`
  gap: 10px;
`;

const Title = styled(Headline4)`
  font-weight: 600;
  color: var(--primary-4);
`;

const ImgRow = styled(FlexRowSpaceBetween)``;

const MainImg = styled.img.attrs({
  src: ravZuckerman,
})`
  width: 180px;
  object-fit: cover;
  clip-path: circle(85px at 86px 86px);

  @media (max-width: 490px) {
    position: absolute;
    width: 115px;
    -webkit-clip-path: circle(45px at center);
    -webkit-clip-path: circle(45px at 47px 46px);
    -webkit-clip-path: circle(54px at 57px 56px);
    clip-path: circle(54px at 57px 56px);
    left: -5px;
    top: -50px;
  }
`;

const Small = styled(SmallText)`
  display: inline;
`;

const LargeQuote = styled(Quote)`
  font-size: var(--large-text);
`;

const P = styled(LargeText)``;

const Footer = styled(FlexRow)`
  margin-top: 30px;
  justify-content: flex-end;
`;

const HomeLink = styled(Link)`
  text-decoration: underline;
  color: var(--primary-5);
`;

const FinalLine = styled(RegularText)`
  font-weight: 600;
  margin-top: 5px;
`;

const About = () => {
  return (
    <Wrapper>
      <Texts>
        <Title>מו״ר הרב אברהם יהושע צוקרמן זצ״ל </Title>

        <ZigzagLine />

        <ImgRow>
          <P>
            <LargeQuote>
              הרב היה כולו תושבע"פ,
              <br />
              תורה מקורית, קצרה,
              <br /> כמעט נבואית, כלשון הירושלמי. <br />
              הרגשתי שכל דיבור איתו היה חד פעמי, <br />
              נדיר, מתנוצץ ונגוז, <br /> וחלקים מעטים ביותר מאותה התנוצצות נגנזו
              בליבי
            </LargeQuote>
            <Small> (נתנאל, תלמיד הרב)</Small>
          </P>

          <MainImg />
        </ImgRow>

        <P>
          את שנגנז בלב רבים אנו רוצים אט אט להתחיל לגלות, לתת לו ביטוי,
          <br /> להוציא לאור, שימשיך להאיר את חיינו באור המיוחד של רבנו.
        </P>

        <P>
          מתוך געגוע עמוק, וידיעה שהרב בגדולת נשמתו נגע ברבים כל-כך, <br />
          התחלנו תלמידיו לאסוף סיפורים, הספדים, הארות, מתוך תקווה שאור תורתו
          ימשיך להאיר בעולם.
        </P>

        <P>
          כל סיפור, כל אמירה, כל הארה - מיוחדים ומאירים באורם הייחודי,
          <br /> חלק גדול, חלק קטן, חלק ארוך וחלק קצר, כולם ביחד יוצרים את
          התמונה השלמה.
        </P>

        <FinalLine>
          נשמח מאד שגם אתם תצטרפו ותקחו חלק בהארת דמותו של רבנו
        </FinalLine>

        <WhatsappButton />
      </Texts>

      <Footer>
        <HomeLink to="/">לקריאה על הרב</HomeLink>
      </Footer>
    </Wrapper>
  );
};

export default About;
